import {filterBy} from "@progress/kendo-data-query";
import {ComboBox} from "@progress/kendo-react-dropdowns";
import React, {useEffect, useState} from "react";
import {useField, useFormikContext} from "formik";
import {ObjUtils} from "../../../utils/ObjUtils.js";

export const ComboBoxInput = ({ label, required, style, disabled = false, onChange, ...otherProps }) => {
    const [field, meta] = useField(otherProps);
    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;
    const [data, setData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const {
        filterable = true,
        data: propData = [],
        textField = "text",
    } = otherProps;

    useEffect(() => {
        if (propData && Array.isArray(propData) && propData.length > 0) {
            if (!ObjUtils.isObject(propData[0])) {
                console.error(`Error: The ComboBoxInput data options must follow this format: [{id: 1, display: "option1"}, ...]
                 If you are using an array of primitive values, then use the PrimitiveComboBoxInput component...`);
            }
            setData(propData);
        }
    }, [propData]);

    const filterData = (filter) => {
        const data = propData.slice();
        return filterBy(data, filter);
    };
    const onFilterChange = (event) => {
        setData(filterData(event.filter));
    };

    const onBlur = () => {
        setData(propData);
        setIsOpen(false);
        field.onBlur(field.name);
    };

    const onClose = () => {
        setData(propData);
        setIsOpen(false);
    };

    const onFocus = () => {
        setIsOpen(true);
    };

    const onOpen = () => {
        setIsOpen(true);
    };



    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
        }
    };
    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <ComboBox
                className={"tgf-kendo-combobox"}
                textField={textField}
                dataItemKey={"id"}
                value={field.value}
                opened={isOpen}
                onBlur={onBlur}
                onOpen={onOpen}
                onClose={onClose}
                onFocus={onFocus}
                onFilterChange={onFilterChange}
                {...otherProps}
                onChange={handleChange}
                disabled={isDisabled}
                data={data}
                label={null} // we set this to null, because label is used in the Label component up above.
                filterable={filterable}
            />
        </>
    );
};